import resolver from 'resolve';
import { resolve as resolveExports, legacy as resolveFields } from 'resolve.exports';
import { arrayFmt } from './array-fmt';
import path from 'path';
import { fileURLToPath } from 'url';
const baseDir = path.dirname(fileURLToPath(import.meta.url));
export const packageFilterBuilder = (path = '.', opts = {}) => {
    const conditions = opts.conditions ?? ['style', 'import', 'require'];
    const fields = opts.fields ?? ['style', 'module', 'main'];
    return pkg => {
        // Check `exports` fields
        try {
            const resolvedExport = resolveExports(pkg, path, { conditions, unsafe: true });
            if (typeof resolvedExport === 'string') {
                pkg.main = resolvedExport;
                return pkg;
            }
        }
        catch {
            /* noop */
        }
        // Check independent fields
        try {
            const resolvedField = resolveFields(pkg, { fields, browser: false });
            if (typeof resolvedField === 'string') {
                pkg.main = resolvedField;
                return pkg;
            }
        }
        catch {
            /* noop */
        }
        return pkg;
    };
};
const defaultOpts = {
    caller: 'Resolver',
    basedirs: [baseDir],
    extensions: ['.mjs', '.js', '.cjs', '.json'],
    preserveSymlinks: true,
    packageFilter: packageFilterBuilder(),
};
const resolverSync = (id, options = {}) => {
    try {
        return resolver.sync(id, {
            ...options,
            pathFilter: (pkg, _path, relativePath) => {
                const result = resolveExports(pkg, relativePath);
                if (result)
                    return result[0];
                return '';
            },
        });
    }
    catch {
        return;
    }
};
export function resolveSync(ids, userOpts) {
    const options = { ...defaultOpts, ...userOpts };
    for (const basedir of options.basedirs) {
        const opts = { ...options, basedir, basedirs: undefined, caller: undefined };
        for (const id of ids) {
            const resolved = resolverSync(id, opts);
            if (resolved)
                return resolved;
        }
    }
    throw new Error(`${options.caller} could not resolve ${arrayFmt(ids)}`);
}
